// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "reserve-online" + "." + "b1f793cc" + ".chunk.css";
};